import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class NumberUtilitiesService {
  private readonly translate = inject(TranslateService);

  public getNumberWithSuffix(
    value: number | null,
    decimalPrecision = 0,
    thousandPrecision = 1,
    ignoreSuffix = false,
  ): string {
    if (value === null || isNaN(value) || value === 0) {
      return '0';
    }

    const abs = Math.abs(value);
    const sign = value < 0 ? '-' : '';
    const formattedNumber = (num: number): string =>
      sign +
      num.toLocaleString(this.translate.currentLang, {
        maximumFractionDigits: thousandPrecision,
        minimumFractionDigits: 0,
      });

    if (ignoreSuffix) {
      return formattedNumber(value);
    }

    if (abs >= 1000000000) {
      return `${formattedNumber(abs / 1000000000)}${this.translate.instant('shared.numberSuffix.billion')}`;
    }

    if (abs >= 1000000) {
      return `${formattedNumber(abs / 1000000)}${this.translate.instant('shared.numberSuffix.million')}`;
    }

    if (abs >= 1000) {
      return `${formattedNumber(abs / 1000)}${this.translate.instant('shared.numberSuffix.thousand')}`;
    }

    return (
      sign +
      abs.toLocaleString(this.translate.currentLang, {
        maximumFractionDigits: decimalPrecision,
        minimumFractionDigits: decimalPrecision,
      })
    );
  }
}
